import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.math.hypot.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import jLink from 'src/components/j-link.vue';
import copyToClipboard from 'quasar/src/utils/copy-to-clipboard.js';;
export default {
  inject: ['reload'],
  components: {
    jLink: jLink
  },
  name: 'pc-header',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '头部导航',
          icon: 'el-icon-chat-line-round',
          content: {
            list: [{
              label: '配置区域',
              link: {}
            }]
          },
          config: [{
            label: '右侧自定义链接配置',
            name: 'list',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              link: {
                label: '链接',
                value: 'link'
              }
            }
          }]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.userInfo;
    },
    noticeTotal: function noticeTotal() {
      return this.$store.state.noticeTotal;
    },
    theme: function theme() {
      return this.$store.state.theme;
    },
    isLogin: function isLogin() {
      return this.$store.state.isLogin;
    },
    nick: function nick() {
      if (/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.userInfo.nick)) {
        return this.userInfo.nick.replace(/^(\d{3})\d*(\d{4})$/, '$1****$2');
      }
      return this.userInfo.nick;
    },
    relationSaleInfo: function relationSaleInfo() {
      return this.$store.state.relationSaleInfo || {};
    }
  },
  watch: {
    widgets: {
      handler: function handler(val) {
        if (!this.widgets.content.isDark) {
          this.$store.commit('set_theme', 'light');
          if (this.$q.dark.isActive) {
            this.$q.dark.toggle();
          }
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // this.$store.dispatch('getRelationSaleInfo')
  },
  methods: {
    set_theme: function set_theme(event) {
      var _this = this;
      var val = this.theme == 'dark' ? 'light' : 'dark';
      if (!document.startViewTransition) {
        this.$store.commit('set_theme', val);
        this.$q.dark.toggle();
        return;
      }
      var x = event.clientX;
      var y = event.clientY;
      var endRadius = Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y));
      var transition = document.startViewTransition(function () {
        _this.$store.commit('set_theme', val);
        _this.$q.dark.toggle();
      });
      transition.ready.then(function () {
        var isDark = _this.$q.dark.isActive;
        var clipPath = ["circle(0px at ".concat(x, "px ").concat(y, "px)"), "circle(".concat(endRadius, "px at ").concat(x, "px ").concat(y, "px)")];
        document.documentElement.animate({
          clipPath: isDark ? [].concat(clipPath).reverse() : clipPath
        }, {
          duration: 500,
          easing: 'ease-in',
          pseudoElement: isDark ? '::view-transition-old(root)' : '::view-transition-new(root)'
        });
      });
    },
    cutI18n: function cutI18n(locale) {
      if (locale == this.$q.cookies.get('Language')) return;
      this.$i18n.locale = locale;
      this.$q.cookies.set('Language', locale);
      this.$store.dispatch('nuxtServerInit');
      this.reload();
    },
    copy: function copy() {
      var _this2 = this;
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      copyToClipboard(val).then(function () {
        _this2.$message.success('复制成功');
      });
    }
  }
};